// The bundled PNG crops of the HiiKER sprite's hazard icons (180×164, i.e. the
// sprite's @2x), named exactly as in the sprite so a later swap to vector art
// is a drop-in. Used outside the map (the details panel, the route warnings
// rows) and on the map only when a style lacks the HiiKER sprite (see
// hazardMissingImage.ts).
//
// `?no-inline`: each icon is ~2KB, under Vite's inline limit, and inlining all
// 23 would put ~70KB of base64 into every map page's bundle; as files they are
// fetched only when shown, and cached.

import icon_flooded_passable from '../../images/hazards/flooded_passable.png?no-inline';
import icon_flooded_blocked from '../../images/hazards/flooded_blocked.png?no-inline';
import icon_tree_passable from '../../images/hazards/tree_passable.png?no-inline';
import icon_tree_blocked from '../../images/hazards/tree_blocked.png?no-inline';
import icon_closed_passable from '../../images/hazards/closed_passable.png?no-inline';
import icon_closed_blocked from '../../images/hazards/closed_blocked.png?no-inline';
import icon_wildlife_passable from '../../images/hazards/wildlife_passable.png?no-inline';
import icon_wildlife_blocked from '../../images/hazards/wildlife_blocked.png?no-inline';
import icon_hard_passable from '../../images/hazards/hard_passable.png?no-inline';
import icon_hard_blocked from '../../images/hazards/hard_blocked.png?no-inline';
import icon_boggy_passable from '../../images/hazards/boggy_passable.png?no-inline';
import icon_boggy_blocked from '../../images/hazards/boggy_blocked.png?no-inline';
import icon_overgrown_passable from '../../images/hazards/overgrown_passable.png?no-inline';
import icon_overgrown_blocked from '../../images/hazards/overgrown_blocked.png?no-inline';
import icon_rockfall_passable from '../../images/hazards/rockfall_passable.png?no-inline';
import icon_rockfall_blocked from '../../images/hazards/rockfall_blocked.png?no-inline';
import icon_ice_passable from '../../images/hazards/ice_passable.png?no-inline';
import icon_ice_blocked from '../../images/hazards/ice_blocked.png?no-inline';
import icon_bridge_passable from '../../images/hazards/bridge_passable.png?no-inline';
import icon_bridge_blocked from '../../images/hazards/bridge_blocked.png?no-inline';
import icon_fire_passable from '../../images/hazards/fire_passable.png?no-inline';
import icon_fire_blocked from '../../images/hazards/fire_blocked.png?no-inline';
import icon_puck_icon_warning from '../../images/hazards/puck_icon_warning.png?no-inline';

import { GENERIC_WARNING_ICON } from './hazardSprite';

/** Sprite name -> bundled image URL. */
export const HAZARD_ICON_URLS: Readonly<Record<string, string>> = Object.freeze({
  flooded_passable: icon_flooded_passable,
  flooded_blocked: icon_flooded_blocked,
  tree_passable: icon_tree_passable,
  tree_blocked: icon_tree_blocked,
  closed_passable: icon_closed_passable,
  closed_blocked: icon_closed_blocked,
  wildlife_passable: icon_wildlife_passable,
  wildlife_blocked: icon_wildlife_blocked,
  hard_passable: icon_hard_passable,
  hard_blocked: icon_hard_blocked,
  boggy_passable: icon_boggy_passable,
  boggy_blocked: icon_boggy_blocked,
  overgrown_passable: icon_overgrown_passable,
  overgrown_blocked: icon_overgrown_blocked,
  rockfall_passable: icon_rockfall_passable,
  rockfall_blocked: icon_rockfall_blocked,
  ice_passable: icon_ice_passable,
  ice_blocked: icon_ice_blocked,
  bridge_passable: icon_bridge_passable,
  bridge_blocked: icon_bridge_blocked,
  fire_passable: icon_fire_passable,
  fire_blocked: icon_fire_blocked,
  [GENERIC_WARNING_ICON]: icon_puck_icon_warning,
});

/** Device-pixel ratio the PNGs were cropped at (the sprite's @2x sheet). */
export const HAZARD_ICON_PIXEL_RATIO = 2;
/** Their size at 1x, as in the sprite: 90×82 for a triangle. */
export const HAZARD_ICON_WIDTH = 90;
export const HAZARD_ICON_HEIGHT = 82;

/** The bundled image for a sprite name, or null for a name that isn't bundled. */
export function hazardIconUrl(name: string | null | undefined): string | null {
  if (!name || !Object.prototype.hasOwnProperty.call(HAZARD_ICON_URLS, name)) return null;
  return HAZARD_ICON_URLS[name];
}
